import React, { useCallback, useEffect, useRef } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Content, PageContainer, TitleContainer } from './NotificationsPage.styles';
import { Text24Bold } from '../../../components/utils/Text/Text.styles';
import { Table } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { selectFetchNotificationsInfo } from '../../../store/slices/collections/slice';
import { fetchNotifications } from '../../../store/slices/collections/asyncThunks';
import NotificationItem from '../../../components/Table/items/NotificationItem/NotificationItem';
import { CRM_ORGANIZATION_MEMBER_ROLE, SOCKET_EVENTS } from '../../../utils/constants';
import { useSocketEvent } from '../../../hooks/useSocketEvent';
import { selectUser } from '../../../store/slices/user/slice';

const NotificationsPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = +searchParams.get('page') || 1;
  const perPage = +searchParams.get('perPage') || 25;
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);
  const { influencerId } = useParams();
  const user = useSelector(selectUser);

  useEffect(() => {
    pathnameRef.current = pathname;
  }, [pathname]);

  const { data, total, pending } = useSelector(selectFetchNotificationsInfo);

  useEffect(() => {
    if (page > 0) {
      dispatch(fetchNotifications({ page, perPage, ...(influencerId && { influencerId }) }));
    }
  }, [dispatch, page, perPage, influencerId]);

  const setPage = useCallback(
    page => {
      const params = new URLSearchParams(searchParams);
      params.set('page', page);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );
  const setPerPage = useCallback(
    value => {
      const params = new URLSearchParams(searchParams);
      params.set('perPage', value);
      params.set('page', 1);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );

  const tableHeader =
    user.role === CRM_ORGANIZATION_MEMBER_ROLE.CHATTER
      ? [{ label: 'Name' }, { label: 'Message' }, { label: 'Time' }]
      : [{ label: 'Name' }, { label: 'Message' }, { label: 'Time' }, { label: 'Cost' }];

  const handleNotification = () => {
    if (pathnameRef.current.includes('notifications')) {
      dispatch(fetchNotifications({ page: 1, perPage, ...(influencerId && { influencerId }) }));
    }
  };

  useSocketEvent(SOCKET_EVENTS.NOTIFICATION, handleNotification);

  return (
    <PageContainer>
      <TitleContainer>
        <Text24Bold>Notifications</Text24Bold>
      </TitleContainer>
      <Content>
        <Table
          headerInformation={tableHeader}
          dataLoading={pending}
          totalCount={total}
          currentPage={page}
          perPage={perPage}
          setPerPage={setPerPage}
          setPage={setPage}
          emptyDataText={'No data'}
          showPerPage
          fullHeight>
          {data.map(notification => (
            <NotificationItem
              key={notification._id}
              chatId={notification.userInfluencer}
              name={notification.name}
              cost={notification.cost}
              type={notification.type}
              createdAt={notification.createdAt}
            />
          ))}
        </Table>
      </Content>
    </PageContainer>
  );
};

export default NotificationsPage;
